export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12095.740da1fb.jpg";